import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';

const ReopenCycleModal = observer(({uiState, modalOpen}) => {
  return (
    <Modal
      size='md'
      title='performance.reopen_modal.Reopen Review Cycle'
      isOpen={modalOpen}
      onHide={() => uiState.closeReopenCycleModal()}
    >
      <div className='mb2'>
        <FormattedMessage id='performance.reopen_modal.DESCRIPTION'/>
      </div>
      <ModalButtons
        saveCaption='performance.reopen_modal.Reopen'
        onSave={() => uiState.reopenCycle()}
        onCancel={() => uiState.closeReopenCycleModal()} />
    </Modal>
  );
});

export default ReopenCycleModal;
